import React from 'react';
import { Link as MuiLink } from '@material-ui/core';

interface Props {
  link: string;
}

const ShowNoteLink: React.FC<Props> = ({ link }) => {
  if (!link) return null;
  return (
    <MuiLink href={link} target="_blank" rel="noopener noreferrer">
      {link}
    </MuiLink>
  );
};

export default ShowNoteLink;
